import SubFilterItem from "./SubFilterItem";
import { useEffect, useState, useRef } from "react";
import { slugify } from "../../../../utils/slugifyString";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const SubFilters = ({
  filter,
  filtersState,
  filterName,
  setFiltersState,
  itemDiv,
  filters,
  setSelectedInstitution,
  filtersKeys,
}) => {
  const filterSearchRef = useRef(null);
  const [filtersSearch, setFiltersSearch] = useState("");
  const [isEmpty, setIsEmpty] = useState(true);
  const [currentFilterKey, setCurrentFilterKey] = useState("");

  useEffect(() => {
    filtersKeys.forEach((key) => {
      if (filter?.slug === filters[key].slug) {
        setCurrentFilterKey(key);
      }
    });
  }, []);

  useEffect(() => {
    if (filtersState[currentFilterKey]?.length > 0) {
      setIsEmpty(false);
    } else {
      setIsEmpty(true);
    }
  }, [filtersState, currentFilterKey]);

  let subfilterItems = [];
  filtersKeys.forEach((key) => {
    if (filter?.slug === filters[key].slug) {
      subfilterItems = filters[key].values.map((item) => {
        if (filtersSearch) {
          if (item.slug.includes(slugify(filtersSearch))) {
            return (
              <SubFilterItem
                item={item}
                setFiltersState={setFiltersState}
                filterKey={key}
                setSelectedInstitution={setSelectedInstitution}
                filtersState={filtersState}
              />
            );
          }
        } else {
          return (
            <SubFilterItem
              item={item}
              setFiltersState={setFiltersState}
              filterKey={key}
              setSelectedInstitution={setSelectedInstitution}
              filtersState={filtersState}
            />
          );
        }
      });
    }
  });

  // useEffect(() => {
  //   console.log(filters[currentFilterKey]);
  //   console.log("key", currentFilterKey);
  //   if (currentFilterKey) {
  //     subfilterItems = filters[currentFilterKey].values.map((item) => {
  //       if (filtersSearch) {
  //         if (item.slug.includes(slugify(filtersSearch))) {
  //           return (
  //             <SubFilterItem
  //               item={item}
  //               setFiltersState={setFiltersState}
  //               filterKey={currentFilterKey}
  //               setSelectedInstitution={setSelectedInstitution}
  //               filtersState={filtersState}
  //             />
  //           );
  //         }
  //       } else {
  //         return (
  //           <SubFilterItem
  //             item={item}
  //             setFiltersState={setFiltersState}
  //             filterKey={currentFilterKey}
  //             setSelectedInstitution={setSelectedInstitution}
  //             filtersState={filtersState}
  //           />
  //         );
  //       }
  //     });
  //   }
  // }, [filtersState, currentFilterKey, filters, filtersSearch, filtersKeys]);

  const handleChange = (e) => {
    setFiltersSearch(e.target.value);
  };

  const emptySearchbar = () => {
    filterSearchRef.current.value = "";
    setFiltersSearch("");
  };

  const resetSubFilters = () => {
    setFiltersState((prev) => ({ ...prev, [currentFilterKey]: [] }));
  };

  return (
    <div className="subfilter-wrapper">
      <div className="subfilter-wrapper-inner">
        <div className="subfilters-search__wrapper">
          <span className="iconReactLeafletsearch"></span>
          <input
            className="subfilters-search"
            type="text"
            onChange={(e) => handleChange(e)}
            placeholder="Rechercher un tag"
            ref={filterSearchRef}
          />
          {filtersSearch && (
            <span
              onClick={emptySearchbar}
              className="icon iconReactLeafletx"
            ></span>
          )}
        </div>
        {!isEmpty && (
          <button
            type="button"
            className="reset-filters"
            onClick={resetSubFilters}
          >
            <span className="iconReactLeafletreset"></span>
          </button>
        )}
      </div>
      <OverlayScrollbarsComponent
        options={{
          className: "overlay-scrollbar os-theme-dark",
          overflowBehavior: {
            x: "hidden",
            y: "scroll",
          },
        }}
      >
        <div className="subfilters-wrapper">{subfilterItems}</div>
      </OverlayScrollbarsComponent>
    </div>
  );
};

export default SubFilters;
